<template>
  <div id="buyerSavePostsPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-bookmark fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">پست های ذخیره شده</span>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col pt-0 ">
                    <v-autocomplete
                        v-model="searchKeyWord"
                        :items="hashtagsItems"
                        append-icon="far fa-magnifying-glass"
                        class="rounded-lg search-combobox"
                        clearable
                        dense
                        placeholder="..Search Hashtag"
                        flat
                        hide-details
                        item-text="Content"
                        item-value="HashTagID"
                        solo
                        @keyup="searchInPostList"
                        @change="searchInPostList"
                        @click:clear="removeSearchHistory">
                    </v-autocomplete>
                  </div>
                </div>
                <masonry
                    id="postGalley"
                    :cols="{default: 3, 1150:2, 700: 2}">
                  <div v-for="(item,i) in posts" :key="i"

                       class="p-1 mx-auto d-block">
                    <v-img v-if="item.FileCoverUrl !== null"
                           :lazy-src="$replaceHttps(item.FileCoverUrl)"
                           :src="$replaceHttps(item.FileCoverUrl)"
                           class=" rounded-11px">

                      <div class="p-2">
                        <div v-if="item.TypeStrucGallery ===2"><i
                            class="fa-solid fa-play  white--text fa-lg shadow-lg"></i></div>
                        <div v-if="item.TypeStrucGallery ===1"><i
                            class="fa-solid fa-images white--text fa-lg shadow"></i></div>

                      </div>
                      <div class="rounded-11px text-center white--text py-2 detail-on-post  col-9 ">
                        <div>

                          <i class="red--text  fa-lg fa-solid fa-bookmark ml-3"
                             @click="removeBookmark(item.bookmarkID)"></i>

                          <span class="mr-3">{{ item.CountLike }}</span>like
                        </div>
                        <div class="mt-3">
                          <router-link
                              :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"><i
                              class="white--text  fa-lg fa-solid fa-eye ml-3"></i>
                          </router-link>
                          <span class="mr-3">{{ item.CountVisit }}</span>view
                        </div>

                      </div>

                    </v-img>
                    <v-img v-else-if="item.TypeStrucGallery === 1"
                           :lazy-src="$replaceHttps(item.FileUrl)"
                           :src="$replaceHttps(item.FileUrl)"
                           class=" rounded-11px">

                      <div class="p-2">
                        <div v-if="item.TypeStrucGallery ===2"><i
                            class="fa-solid fa-play  white--text fa-lg shadow-lg"></i></div>
                        <div v-if="item.TypeStrucGallery ===1"><i
                            class="fa-solid fa-images white--text fa-lg shadow"></i></div>

                      </div>
                      <div class="rounded-11px text-center white--text py-2 detail-on-post  col-9 ">
                        <div><i class="red--text  fa-lg fa-solid fa-bookmark ml-3"
                                @click="removeBookmark(item.bookmarkID)"></i> <span
                            class="mr-3">{{ item.CountLike }}</span>like
                        </div>
                        <div class="mt-3">
                          <router-link
                              :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.VendorSocialNetworkID}}"><i
                              class="white--text  fa-lg fa-solid fa-eye ml-3"></i>
                          </router-link>
                          <span class="mr-3">{{ item.CountVisit }}</span>view
                        </div>

                      </div>

                    </v-img>
                  </div>
                </masonry>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText"></div>

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "BuyerSavePosts",
  metaInfo: {
    title: 'ایوان خانه- پست های ذخیره شده',
  },
  components: {BackBar},
  data: () => ({
    posts: [],
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    hashtagsItems:[],
    allPostList:[],
    hasResult:true,
    searchKeyWord:null

  }),
  mounted() {
    this.getBuyersPostBookmark()
  },
  methods: {
    getBuyersPostBookmark() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkVendor/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let posts = json.posts
            let bookmarkList = json.list
            for (let i = 0; i < posts.length; i++) {
              let findInBookmark = bookmarkList.find(x => x.RelationID === posts[i].VendorSocialNetworkID)
              posts[i].bookmarkID = findInBookmark.BookMarkID
            }
            this.posts = posts
            this.allPostList=posts
            this.$store.commit('addUserPostsBookMarks', this.posts)


            let AllPostsHashtags = []
            for (let i = 0; i < posts.length; i++) {
              let selectedPostHashtags = posts[i].SelectedHashTags
              if(selectedPostHashtags !== null) {
                for (let j = 0; j < selectedPostHashtags.length; j++) {
                  AllPostsHashtags.push(selectedPostHashtags[j])
                }
              }
            }
            let postsHashtags = [...new Set(AllPostsHashtags)]
            let allHashtags = this.$store.getters.getHashtags
            let hashtagsItems = []
            for (let i = 0; i < postsHashtags.length; i++) {
              let findHashtag = allHashtags.find(x => x.HashTagID === postsHashtags[i])
              if (findHashtag !== undefined) {
                hashtagsItems.push(findHashtag)
              }
            }
            this.hashtagsItems = hashtagsItems
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    },
    removeBookmark(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("BookMarkID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/RemoveBookMark", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false

            if (resStatus === 200) {
              this.bookMarkActive = false
              this.getBuyersPostBookmark()
              this.$store.commit('addOrRemovePostBookMarkItemToList', id)
            }
            this.resultText = result
            this.showResult = true


          })
          .catch(error => console.log('error', error));
    },
    searchInPostList() {
      let allPosts = this.allPostList
      let result =[]
      for(let i =0; i<allPosts.length ;i++){
        if(allPosts[i].SelectedHashTags !== null) {
          let find = allPosts[i].SelectedHashTags.find(x => x === this.searchKeyWord)
          if (find !== undefined) {
            result.push(allPosts[i])
          }
        }
      }
      if (this.searchKeyWord === '' || this.searchKeyWord === null) {
        this.posts = this.allPostList
        this.hasResult = true
      } else {
        if (result.length === 0) {
          this.hasResult = false
        } else {

          this.posts = result
        }
      }

    },
    removeSearchHistory() {
      this.searchKeyWord = null
      this.posts = this.allPostList
      this.hasResult = true
    },

  }
}
</script>

<style scoped>

</style>
